import { CONST_ADMIN_USER } from '@/services/shared';
import { RouteConfig } from 'vue-router';

const analysisComponentRouter: RouteConfig[] = [];

export default analysisComponentRouter;
